import React from 'react';
import {Stack, Typography} from '@mui/material';
import SegmentedMeter from '../../../components/SegmentedMeter';
import {similarityFilledBarCount} from './similarityLabels';

const SIMILARITY_SEGMENTS = 5;

/**
 * Five-segment similarity meter (20% per segment) with percent label.
 * Uses the ICD-203 draft SegmentedMeter styling.
 */
export default function SimilarityScoreBars({percent = 0, compact = true}) {
    const pct = Math.max(0, Math.min(100, Number(percent) || 0));
    const filled = similarityFilledBarCount(pct);

    return (
        <Stack
            direction="row"
            spacing={0.5}
            alignItems="center"
            flexWrap="wrap"
            useFlexGap
            data-testid="similarity-score-bars"
        >
            <Typography variant="caption" color="text.secondary" sx={{lineHeight: 1.2}}>
                Similarity:
            </Typography>
            <SegmentedMeter
                filled={filled}
                total={SIMILARITY_SEGMENTS}
                size={compact ? 'compact' : 'default'}
                data-testid="similarity-score-bar-track"
                aria-label={`Similarity ${pct}%`}
            />
            <Typography variant="caption" fontWeight={600} sx={{lineHeight: 1.2}}>
                {pct}%
            </Typography>
        </Stack>
    );
}
